import { primitiveTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const formContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["2x"],
  paddingTop: primitiveTokens.sizing["2x"],
  paddingBottom: primitiveTokens.sizing["2x"]
});
